import { createFileRoute } from "@tanstack/react-router";
import { FormBuilderPage } from "@/features/formbuilder/FormBuilderPage";

export const Route = createFileRoute("/_app/forms/$form/edit")({ component: Page });

function Page() {
  const { form } = Route.useParams();
  return <FormBuilderPage formKey={form} />;
}
